import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faBan } from '@fortawesome/free-solid-svg-icons';
import { accessLocalStorage } from '../../services';

const ReportTable = ({ call, role }) => {
  let showRecs = { icon: '', path: '', target: '' };
  const { data, identificador, origem, origem_secundaria, destino, destino_secundario, fila, duracao, status, tipo, protocolo, aguardando } = call;  

  let url = window.location.href;
  url = url.split('/')[2];

  const date = new Date(data);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  // Função para fazer download seguro com token
  const handleDownload = async (protocolo) => {
    try {
      // Obter token do localStorage usando o serviço padrão do sistema
      const userData = accessLocalStorage.getUserLocalStorage();
      const token = userData?.token;
      
      if (!token) {
        alert('Token de autenticação não encontrado. Faça login novamente.');
        return;
      }

      // Fazer requisição com token (sem prefixo "Bearer" - padrão do sistema)
      const response = await fetch(`//${url}/api/download/file/${protocolo}`, {
        method: 'GET',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        // Tentar obter mensagem de erro do JSON
        try {
          const errorData = await response.json();
          console.error(`❌ [FRONTEND] Erro no download:`, errorData);
          
          if (response.status === 401) {
            alert('Token expirado ou inválido. Faça login novamente.');
          } else if (response.status === 403) {
            alert(`Acesso negado: ${errorData.message || 'Você não tem permissão para baixar este arquivo.'}`);
          } else if (response.status === 404) {
            alert(`Arquivo não encontrado: ${errorData.message || 'O arquivo de gravação não foi encontrado.'}`);
          } else {
            alert(`Erro no download: ${errorData.message || 'Erro interno do servidor.'}`);
          }
        } catch (jsonError) {
          // Se não conseguir fazer parse do JSON, mostrar erro genérico
          alert(`Erro no download (${response.status}): ${response.statusText}`);
        }
        return;
      }

      // Se chegou até aqui, o download foi autorizado
      // Criar blob e fazer download
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      
      // Criar link temporário para download
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `${protocolo}`;
      // link.download = `${protocolo}.wav`;
      document.body.appendChild(link);
      link.click();
      
      // Limpar
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

    } catch (error) {
      alert('Erro de conexão. Verifique sua internet e tente novamente.');
    }
  };

  // Componente do botão de download
  const DownloadButton = ({ protocolo }) => (
    <button 
      onClick={() => handleDownload(protocolo)}
      className="button is-small is-ghost"
      title={`Baixar gravação: ${protocolo}`}
      style={{ border: 'none', background: 'none', cursor: 'pointer' }}
    >
      <FontAwesomeIcon icon={faPlay} fixedWidth />
    </button>
  );

  // Definir qual componente mostrar baseado na role e protocolo
  const adminTd = protocolo ? <DownloadButton protocolo={protocolo} /> : <FontAwesomeIcon icon={faBan} fixedWidth />;
  const userTd = <FontAwesomeIcon icon={faBan} fixedWidth />;

  const dateBr = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;

  return (
    <tr className='is-size-7 has-text-centered '>
      <td>{`${dateBr} ${time}`}</td>
      <td>{identificador}</td>
      <td>{origem}</td>
      <td>{origem_secundaria}</td>
      <td>{destino}</td>
      <td>{destino_secundario}</td>
      <td>{fila}</td>
      <td>{aguardando}</td>
      <td>{duracao}</td>
      <td>{tipo}</td>
      <td>{status}</td>
      <td>{protocolo}</td>
      <td>{ role === 'user' || protocolo === '' ? userTd : adminTd }</td>
    </tr>
  )
}

ReportTable.propTypes = {
    data: PropTypes.string,
    origem: PropTypes.string,
    origem_secundaria: PropTypes.string,
    fila: PropTypes.string,
    destino: PropTypes.string,
    destino_primario: PropTypes.string,
    status: PropTypes.string,
    aguardando: PropTypes.number,
    duracao: PropTypes.string,
    tipo: PropTypes.string,
    id: PropTypes.string,
    protocolo: PropTypes.string,
  };

export default ReportTable;
